import { ReactComponent as Pools } from 'assets/svg/icons/Pools.svg'
import { ButtonPrimary } from 'components/Button'
import { useContext } from 'react'
import { useToggleWalletModal } from 'state/application/hooks'
import styled, { css, ThemeContext } from 'styled-components'
import { ThemedText } from 'theme'

const IconStyle = css`
  width: 40px;
  height: 40px;
  margin-bottom: 0.5rem;
`

const Icon = styled(Pools)`
  ${IconStyle}
`

export const ErrorContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: auto;
  padding: 24px 0;
  max-width: 300px;
`

interface EmptyStateProps {
  message: string
  showConnectButton?: boolean
}

export function EmptyState({ message, showConnectButton = true }: EmptyStateProps) {
  const theme = useContext(ThemeContext)
  const toggleWalletModal = useToggleWalletModal()

  return (
    <>
      <ThemedText.DeprecatedBody color={theme.deprecated_text3} textAlign="center">
        <Icon strokeWidth={1} />
        <div>{message}</div>
      </ThemedText.DeprecatedBody>

      {showConnectButton && (
        <ButtonPrimary style={{ marginTop: '1em', padding: '8px 16px', width: '140px' }} onClick={toggleWalletModal}>
          Connect wallet
        </ButtonPrimary>
      )}
    </>
  )
}
